module.exports = __webpack_public_path__ + "img/4.cf78d647.png";